module.exports = __webpack_public_path__ + "img/jiangshizhuji.0ca01c66.png";